import React from 'react';
import { GenericToolbar } from '../GenericToolbar';
import { AppRoute } from '../../routes';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { ManageAlarmsTabs } from '.';
import { AlarmFilterProvider } from '../../data/DataProviders/AlarmFilterProvider';
import { isRecordFound, useSelectedOrganizationData } from '../../hooks/data-hooks';
import { getUserId, useAuthState } from '../AuthContextProvider';
import { LocationListDataProvider } from '../../data/DataProviders/LocationListDataProvider';

type Props = {
    tabVal?: string;
    testId?: string;
    appRoute: AppRoute;
};

export const ManageAlarms: React.FC<Props> = () => {
    // const Tbvalue = props.tabVal?.toLowerCase() === DeviceTab.sensorTrend.toLowerCase() ? 4 : 0 || props.tabVal?.toLowerCase() === DeviceTab.phaseResolvedGraph.toLowerCase() ? 5 : 0;
    const { t } = useLanguageLocale();
    const selectedOrganizationData = useSelectedOrganizationData();
    const orgId = isRecordFound(selectedOrganizationData) ? selectedOrganizationData.value.id : '';
    const authState = useAuthState();
    const userId = getUserId(authState) || '';

    return (
        <>
            <div className="">
                <GenericToolbar title={t('MANAGEALARMS.TITLE')} subtitle={t('MANAGEALARMS.SUBTITLE')} />
                <LocationListDataProvider organizationId={orgId} userId={userId} operation="view">
                    <AlarmFilterProvider organizationId={orgId} userId={userId}>
                        <ManageAlarmsTabs organizationId={orgId} userId={userId} />
                    </AlarmFilterProvider>
                </LocationListDataProvider>
            </div>
        </>
    );
};
